<!--快递员查快递 -->
<template>
  <div>
    <van-sticky>
      <van-tabs
        :color="$theme.main_color_btn_bg"
        class="div-tab"
        :border="false"
        :active="active"
        @change="onChange"
        :ellipsis="false"
      >
        <van-tab title="待接单" :info="numObj.waitCollectCount==0?'':numObj.waitReceiveCount" :name="0"></van-tab>
        <van-tab title="待打印" :info="numObj.waitCollectCount==0?'':numObj.waitPrintCount" :name="1"></van-tab>
        <van-tab title="已打印" :name="3"></van-tab>
        <van-tab title="已取消" :name="2"></van-tab>
      </van-tabs>
      <div class="tab-sx">
        <div class="item">
          <van-field class="tex" v-model="searchval" placeholder="蜜蜂账户 / 寄件人手机号或姓名 / 订单号 / 收件人手机号" />
          <van-button icon="search" class="btn" @click="onSearch"></van-button>
        </div>
        <div class="dv2" @click="onResetForm">
          <van-icon name="replay" size="20px"/>
        </div>
      </div>
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        style="min-height: 93vh"
        v-model="isLoading"
        :finished="finished"
        finished-text="没有更多数据"
        @load="getInit"
      >
        <div v-for="(item,index) in list" :key="index">
          <expressItem
            :item.sync="item"
            :pIndex="index"
            :active="active"
            @reviceOrder="onReviceOrder"
            @cancelOrder="onCancelOrder"
            @printOrder="onPrintOrder"
            @againPrintOrder="againPrintOrder"
          />
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import http from "@/utils/axios";
import expressItem from "@/views/courier/components/item";
import env from "@/utils/env";
export default {
  props: {},
  data() {
    return {
      loading: false,
      active: 0,
      searchval:'',
      refreshing: false,
      isLoading: false,
      finished: false,
      list:[],
      pageNum:1,
      pageSize: 20,
      total:0,
      startTime:'',
      endTime:'',
      numObj:{},
      justOnceTime: false,
    }
  },
  watch:{
    // 'wsData.data'(val,oldval){
    //   // val && this.changeSetFun()
    //   console.log(val, oldval)
    // },
    'resultFrom.printStatus'(val,oldval){
      if(val == 3 || val == val == 4 || val == 5){
        this.haveResult = true
        // this.closeEmptyFun()
      }
    }
  },
  destroyed(){
    this.closeEmptyFun()
  },
  methods: {
    onListenFunc(message) {
      let that = this
      if (message.data == 'ticketReceive') {
        this.setDefaultInit()
      }
    },
    initWebSocketFun(){
      if ('WebSocket' in window){
        console.log(env.basewsURL)
        this.ws = new WebSocket(env.basewsURL+'order/websocket/expressCode/ticketPush4652');
        this.ws.onmessage =  (res=>{
          console.log("数据已接收...数据为："+res.data);
          this.wsData = res
          this.onListenFunc(res)
        }) 
        this.ws.onopen=(res=>{
          console.log("socket连接成功")
          //每两秒钟建立一次通话连接
          this.eachPrintResultFun();
        })
        this.ws.onerror =(res=>{
          console.error("WebSocket error observed:", res);
          //重连
          this.reconnectWebSocket()
        })
        this.ws.onclose =(res=>{
          console.log("WebSocket close");
          clearInterval(this.inteervalTime);
          this.ws = null
        })
      }
    },
    eachPrintResultFun(){
      this.inteervalTime = setInterval(()=>{
        this.ws.send("connect");
      },3000)
    },
    reconnectWebSocket(){
      if(this.lockReconnect) return;
      this.lockReconnect = true;
      setTimeout(() =>{
        this.initWebSocketFun();
        //如果只需要重连一次则不需要把lockReconnect再次设为false
        this.lockReconnect = false;
      }, 5000);
    },
    closeEmptyFun(){
      this.lockReconnect = true;
      this.ws && this.ws.close();
    },
    closeFun(){
      this.closeEmptyFun()
      this.haveResult = false;
      this.havePrinting = false;
      clearInterval(this.inteervalTime);
    },
    onResetForm () {
      this.searchval = ""
      this.setDefaultInit()
    },
    onReviceOrder (item) {
      http({
        url: 'order/express/tackPush/' + item.pushId,
        method: "POST",
        parmes: {}
      }).then(rps => {
        if (rps.code == 200 && rps.data) {
          this.$dialog.alert({
            message: '接单成功',
            theme: 'round-button',
          }).then(() => {})
          let index = this.list.findIndex(element => element.id == item.id)
          if (index != -1) {
            this.list.splice(index, 1)
          }
        }
      }).catch(rps=>{
        this.$loading.hide()
      });
    },
    onCancelOrder (item) {
      http({
        url: 'order/express/cancelPush/' + item.pushId,
        method: "POST",
        parmes: {}
      }).then(rps => {
        if (rps.code == 200 && rps.data) {
          let index = this.list.findIndex(element => element.id == item.id)
          if (index != -1) {
            this.list.splice(index, 1)
          }
        }
      }).catch(rps=>{
        this.$loading.hide()
      });
    },
    onPrintOrder (item) {
      http({
        url: 'order/express/push/print/' + item.pushId,
        method: "POST",
        parmes: {}
      }).then(rps => {
        if (rps.code == 200 && rps.data.printResult) {
          this.$dialog.alert({
            message: '打印完成',
            theme: 'round-button',
          }).then(() => {})
          let index = this.list.findIndex(element => element.id == item.id)
          if (index != -1) {
            this.list.splice(index, 1)
          }
        }
      }).catch(rps=>{
        this.$loading.hide()
      });
    },
    againPrintOrder (item) {
      http({
        url: 'order/admin/reprintDeliverBill/' + item.subOrderId,
        method: "POST",
        parmes: {}
      }).then(rps => {
        if (rps.code == 200 && rps.data) {
          this.$dialog.alert({
            message: rps.data.result === false ? rps.data.message : '打印完成',
            theme: 'round-button',
          }).then(() => {})
        }
      }).catch(rps=>{
        this.$loading.hide()
      });
    },
    async getInit(){
      this.isLoading = false;
      if(!this.justOnceTime){
        this.power = await this.getPowerFun();
      }
      if(Object.keys(this.power).length !== 0){
        // this.getNumFun();
        this.onLoad();
      }
    },
    async getPowerFun() {
      let res = {};
      await http({
        url: "order/app/accessControl/allowedList",
        method: "GET",
      })
        .then((rps) => {
          if (rps.code === 200) {
            this.justOnceTime = true;
            //防止当前账号什么权限都没开通，因为有接口先后访问的限制，前端为了方便一些逻辑上的控制，自定义了可以查看数据的权限
            res['SELF_POWER_LOOK']= 'SELF_POWER_LOOK'
            rps.data.forEach((element) => {
              res[element] = element;
              element == 'CASHIER_SYSTEM_INPUT' && (this.familiesPassStatus = '1')
            });
          }
        })
        .catch((rps) => {});
      return res
    },
    onChange(tab) {
      this.active = tab
      this.setDefaultInit()
    },
    onRefresh() {
      this.$loading.show()
      setTimeout(() => {
        this.pageNum = 1;
        this.list = [];
        //恢复不是最后一页
        this.finished = false;
        this.onLoad();
      }, 1000);
    },
    onLoad() {
      this.isLoading = true;
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
      });
      http({
        url: 'order/express/push/count',
        method: 'GET'
      }).then(rps => {
        if (rps.code == 200) {
          this.numObj = rps.data
        }
      }).catch(rps=>{
        this.$loading.hide()
      });
      http({
        url: 'order/express/push/list',
        method: "POST",
        parmes:{
          pushStatus: this.active,
          keyWord:this.searchval.trim(),
          // printTimeGt: this.startTime,
          // printTimeLt: this.endTime,
          pageIndex: this.pageNum,
          pageSize: this.pageSize
        }
      }).then(rps => {
        this.render(rps)
      }).catch(rps=>{
        this.$loading.hide()
      });
    },
    render(rps){
      if (rps.data.pages == 0) {
        this.finished = true;
      } else {
        if (rps.data.list.length === 0) {
          this.finished = true;
        } else {
          this.finished = false;
          this.pageNum++;
        }
        this.list = this.list.concat(rps.data.list);
        this.list.forEach(element => {
          element.showMore = false;
        });
      }
      this.isLoading = false;
      this.$loading.hide();
    },
    onSearch(){
      if(!this.searchval.trim()){
        this.$toast('请输入关键字查询')
        return
      }
      this.setDefaultInit()
    },
    setDefaultInit(){
      this.$loading.show()
      setTimeout(() => {
        this.pageNum = 1;
        this.list = [];
        this.onLoad();
      }, 200);
    },
    callbackFun(){
      this.setDefaultInit()
    }
  },
  created() {
    //权限接口
    //获取tab数量接口
    this.initWebSocketFun()
  },
  mounted(){},
  components: {expressItem},
};
</script>
<style lang="less" scoped>
.div-tab{
  border-top: 1PX solid #F2F2F2;
  border-bottom: 1PX solid #F2F2F2;
}
.tab-sx {
  margin-bottom: 10px;
  background-color: #ffffff;
  height: 84px;
  font-size: 24px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /deep/.van-cell{
    padding: 0;
  }
  /deep/.van-field__control {
    width: 550px;
    height: 60px;
    background: #F7F7F7;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    -webkit-appearance: none;
    padding-left: 20px;
    font-size: 20px;
  }
  input{
    -webkit-appearance: none;
  }
  .btn{
    width: 60px;
    height: 60px;
    background: var(--epButtonColor);
    color: var(--epTextColor);
    border-radius: 10px;
    margin-left: -3px;
  }
  .item {
    display: flex;
  }
  .dv2{
    margin-left: 40px;
    width: 200px;
  }
}
</style>